import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div {{did-insert this.updateTooltip.perform}} {{did-update this.updateTooltip.perform @text}} ...attributes>\n    {{~yield~}}\n</div>")